export class Site {
  public static siteId = 3;
}
